import { TextInputBare, useToast } from "@validereinc/common-components";
import React, { useState } from "react";

const AnnotationNumberInput = ({
  value,
  onChange,
  label,
}: {
  value: number;
  onChange: (value: number) => void;
  label: string;
}) => {
  const [intervalValue, setIntervalValue] = useState<string>(value.toString());
  const { toast } = useToast();

  const onValueChange = (value: number) => {
    setIntervalValue(value.toString());
    onChange(value);
  };

  return (
    <TextInputBare
      value={intervalValue}
      onChange={(v) => {
        setIntervalValue(v);
      }}
      onBlur={() => {
        const newValue = parseFloat(intervalValue);
        if (isNaN(newValue)) {
          toast.push({
            intent: "error",
            description: `Please enter a valid number for ${label}`,
          });
          onValueChange(0);
          return;
        }
        onValueChange(newValue);
      }}
      type="text"
    />
  );
};

export default AnnotationNumberInput;
